import styled, { css } from 'styled-components';
import { Paragraph, Header3 } from '../../typographies';
import { ColorAddiFontAction, ColorAddiFontSecondary } from '@addi/foundation/dist/web/colors';
const flexCenter = css `
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const Title = styled(Header3) `
    margin: 0;
    text-align: center;
`;
export const Description = styled(Paragraph) `
    width: 32ch;
    text-align: center;
    color: ${ColorAddiFontSecondary};
`;
export const Container = styled.div `
    ${flexCenter}
    flex-direction: column;
    height: 80vh;
`;
export const Footnote = styled(Paragraph) `
    text-align: center;
    width: 32ch;
    margin: 25px 0;
    color: ${ColorAddiFontAction};
`;
//# sourceMappingURL=StatusScreen.Styled.js.map